import { Skeleton } from '@eliadmin/core/src/components/ui/skeleton';

export const ReferenceSkeletonItem = () => {
  return (
    <div className="relative col-span-1 flex w-full flex-col items-start justify-start gap-6">
      <Skeleton className="h-[330px] w-full rounded-[24px] bg-slate-300 sm:h-[375px] md:rounded-[48px]" />
      <div className="flex w-full items-center justify-between gap-3">
        <div className="flex w-full flex-col gap-2">
          <div className="flex w-full items-center justify-start gap-3">
            <Skeleton className="aspect-video h-[24px] w-[40px] bg-slate-300" />
            <Skeleton className="aspect-video h-[24px] w-[40px] bg-slate-300" />
          </div>
          <Skeleton className="h-[40px] w-[240px] bg-slate-300 sm:w-[300px]" />
        </div>
        <Skeleton className="aspect-square min-w-12 rounded-full bg-slate-300 sm:min-w-14" />
      </div>
    </div>
  );
};
